import { IPanelProps } from "core/decorators/Panel";
import UrlUtil from "core/util/UrlUtil";
import ConfigUtil from "core/util/config/ConfigUtil";
import AbstractTokenSession from "core/util/session/AbstractTokenSession";
import TokenSession from "core/util/session/TokenSession";

/**
 * @overview: Gets called on every page requests and checks whether user has permission for access
 *
 * @author: Pravin
 */
const authRouteComponent = (pages: Array<IPanelProps<any>>, location: any, success :()=> JSX.Element| null) => { 
	try{
		let path = getCurrentPath(location.pathname);
		const page= getCurrentPage(pages, path);
		//In case of no page found allow page to render.
		if(!page) return success();			
		
		// page found check permissions of page
		let type = getPermission(page);

		// Redirect to SSO login for anonymous user
		if (type === "allAllowed" && !TokenSession.isAuthenticated()) {
			const attributs = page.config["__attrs"];
			if (attributs && attributs.length > 0) {
				attributs.map(item => {
					if (item.key === "redirectToLogin" && item.value === "true") {
						window.location.replace(UrlUtil.getGatewayRedirectLink(
							UrlUtil.getCurrentPath(true).slice(1),
							UrlUtil.getCurrentParams()
						));		
					}
				});
			}
		}		
	

		 if (
			type !== "allAllowed" &&
			type !== "anonymous" &&
			!TokenSession.isAuthenticated()
		) {
			throw "Insufficent Permissions";
		} else return success();
	} catch{
		//in case of insufficent persmission initiate login flow
		AbstractTokenSession.refresh();
	}
	
};

const getCurrentPath = (routerPath: string): string => {
	let appPath = ConfigUtil.getEnvConfig().appPath;
	//removes leading and trailing slash from path
	const path = routerPath.replace(/(^\/)|(\/$)/g, "");
	// get last Subdirectory of URL as page path
	const paths = path.split("/");

	//ingoring appPath from url
	return appPath.includes(paths[paths.length - 1]) ? "": paths[paths.length - 1];
};

const getCurrentPage=(pages: Array<IPanelProps<any>>, path: string)=>{
	return pages.find(page => path === page.config.path);	
}

const getPermission = (page: IPanelProps<any>) => {
	let type = "";
	const permissions = page.config["__permissions"];
	if (permissions) type = permissions.data ? permissions.data.state : "";
	return type;
};

export default authRouteComponent;


// WEBPACK FOOTER //
// ./src/core/components/layout/AuthRouteComponent.ts